export default __webpack_public_path__ + "static/media/account-circle.1df05807.svg";